exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-payment-details {\n  border-radius: 3px;\n  width: 100%;\n  max-width: 280px;\n  padding: 5px;\n}\n.card-payment-details .header {\n  display: flex;\n  height: 50px;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #0B486B;\n  font-weight: bold;\n  font-size: 16px;\n  color: #0B486B;\n}\n.card-payment-details .list-itens-details {\n  margin-top: 8px;\n}\n.card-payment-details .list-itens-details .list-item {\n  font-size: 12px;\n  border: none;\n  padding: 3px;\n}\n.card-payment-details .list-itens-details .list-item::before {\n  content: \" - \";\n}", ""]);

// exports
